import React from 'react';
import { Box } from '@material-ui/core';
import { PasslyAlert } from '@app/componentsV2';
import { useTypedTranslation } from '@app/hooks';
import { basicService } from '@app/services';
import { hasDefaultOrgAdminPermission, isDefaultOrgUser, isLoggedInToDefaultOrg } from '@app/helpers';

interface IProps {}

const PasslyEolBanner: React.SFC<IProps> = () => {

    const { translation } = useTypedTranslation();

    const deadline = new Date(2026, 0, 1);
    const shouldShow = new Date() < deadline && hasDefaultOrgAdminPermission() && isDefaultOrgUser() && isLoggedInToDefaultOrg() && basicService.isEolBannerEnabled();

    return (
    <>
        {shouldShow && (
            <Box mb={2}>
                <PasslyAlert severity={'info'} elevation={6} variant={'outlined'}>
                    <div>
                        <span><b>{translation('PASSLY_EOL_BANNER')}</b></span>
                        <span>{translation('PASSLY_EOL_BANNER_2')}<a target='_blank' href='https://helpdesk.kaseya.com/hc/en-gb/articles/28814450103185-End-of-life-for-Passly'>{translation('PASSLY_EOL_BANNER_3')}</a></span>
                    </div>
                </PasslyAlert>
            </Box>
        )}
    </>);
};

export default PasslyEolBanner;